module.exports = __webpack_public_path__ + "img/student_14.b68f9a54.png";